/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */

import React, { SetStateAction, useCallback, useEffect, useRef } from "react";
import Draggable from "react-draggable";
import { CloseOutlined } from "@material-ui/icons";
import RcButton from "../UiUtilities/Button";
import SAI, { StarSVG } from "./Sai";

interface DialerProps {
  mode: string; 
    clientId: string;
  rcAccessToken: string;
  setSai: any;
  userUri: string | undefined;
  token: string;
  userLeaderboardApi: any;
}

interface DraggableState {
  hover: boolean;
  activeDrags: number;
  deltaPosition: { x: number; y: number };
  controlledPosition: { x: number; y: number };
}

class SaiDraggableWrapper extends React.Component<DialerProps, DraggableState> {


  constructor(props: DialerProps) {
    super(props);
    this.state = {
      hover: false,
      activeDrags: 0,
      deltaPosition: { x: 0, y: 0 },
      controlledPosition: { x: -400, y: 200 },
    };
  }


  onStart = (e: any) => {
     this.setState({ activeDrags: this.state.activeDrags + 1 });
  };

  onStop = () => {
     this.setState({ activeDrags: this.state.activeDrags - 1 });
  };

  handleHoverIn = () => {
    this.setState({ hover: true });
  };

  handleHoverOut = () => {
    this.setState({ hover: false });
  };

  handleClose = () => {
    this.props.setSai(false);
  };
  
 
  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition, controlledPosition } = this.state;
    const { mode, rcAccessToken, clientId, setSai, userUri, token, userLeaderboardApi} = this.props;
    const { hover } = this.state;

    return (
      <Draggable
        bounds="#root"
        handle=".draggable-handle"
        defaultPosition={{ x: 0, y: 0 }}
        // position={deltaPosition}
        scale={1}
        {...dragHandlers}>
            <div
                onMouseEnter={this.handleHoverIn}
                onMouseLeave={this.handleHoverOut}
                className={`draggable-container ${mode === "light" ? "light" : "dark"} ${
                hover ? "hover" : ""
                }`}
                style={{
                position: "fixed",
                marginTop: 30,
                bottom: 100,
                left: 100,
                zIndex: 899000,
                resize: 'both'
                }}>
            <div className={`draggable-handle ${hover ? "hover" : ""} ${ mode === "light" ? "light" : "dark"}`}  style={{display: 'flex', alignItems: 'center'}} >
                <span className="dragging-handle"style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
                    <div className="dragging-handle-left" style={{width:"100%", background: mode === 'light' ? "#e9eff3" : '#545452', borderRadius: 5, display: 'flex', justifyContent: 'start', alignItems: 'center', height: 19, border: mode === 'light' ? "1px solid #dfdfdf" : 0, marginRight: 10}}>
                        {/* <img className="dialer-logo" draggable="false" alt="logo" />  */}
                        <StarSVG />
                        <span className="notranslate">SAi</span>

                    </div>
                    <RcButton onClick={() => setSai(false)} color='white' style={{borderRadius: 50, maxHeight: 18, minHeight: 18, minWidth: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', maxWidth: 18}} size="xs" bg='rgb(211, 43, 46)' >
                        <CloseOutlined fontSize="small" style={{width: 10, height: 10}} />
                    </RcButton>
                </span>
            </div>
            <SAI 
              userUri={userUri} 
              mode={mode} 
              token={token} 
              userLeaderboardApi={userLeaderboardApi}
            />
       </div>
      </Draggable>
    );
  }
}

export default SaiDraggableWrapper;
